// Canonical enum-to-label helpers. Source the labels from the shared *Def
// registries rather than hand-rolled maps so we stay in lockstep when new
// values are added.

import { carePhaseDefs } from '@shared/CarePhaseDef';
import { careEnvironmentDefs } from '@shared/CareEnvironmentDef';
import { fundingPolicyTypeDefs } from '@shared/FundingPolicyTypeDef';

function resolveLabel<T extends { label: string }>(
  defs: Record<string | number, T | undefined>,
  value: number | string | undefined | null,
): string {
  if (value === undefined || value === null || value === '') return '—';
  const def = defs[value as number | string];
  return def?.label ?? String(value);
}

export function carePhaseLabel(value: number | string | undefined | null): string {
  return resolveLabel(carePhaseDefs as Record<string | number, { label: string }>, value);
}

export function careEnvironmentLabel(value: number | string | undefined | null): string {
  return resolveLabel(careEnvironmentDefs as Record<string | number, { label: string }>, value);
}

export function fundingPolicyTypeLabel(value: number | string | undefined | null): string {
  return resolveLabel(fundingPolicyTypeDefs as Record<string | number, { label: string }>, value);
}
